import {
  removeCircleOutline,
  lockClosed,
  mail,
  logOut,
  person,
  phonePortrait,
  bug,
  list,
} from "ionicons/icons";
import { ReactElement, useContext, useMemo, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import Container from "../../components/atoms/Container";
import Icon from "../../components/atoms/Icon";
import AuthContext from "../../contexts/AuthContext";
import { useConfig } from "../../contexts/ConfigContext";
import { IdentificationMethodEnum } from "../../types/profile";
import ChangePwdModal from "./ChangePasswordModal";
import LeaveStudyModal from "./LeaveStudyModal";
import LegalMentionModal from "./LegalMentionModal";
import ReportBugModal from "./ReportBugModal";
import { useResonanceLayout } from "../../components/organisms/ResonanceContext/ResonanceLayoutContext";
import { useHistory, useParams } from "react-router"; // Added this line
import { resetCaches } from "../../services/questionnaire.service"; // Add this line
import {
  InvitationChannelDisplayType,
  InvitationChannelEnum,
  sendInvitationFormType,
} from "../../types/invitation.types";
import { sendEmail } from "../../services/email.service";
import LanguageSelectorModal from "../../components/molecules/LanguageSelector/LanguageSelectorModal/LanguageSelectorModal";
import { languageOutline } from "ionicons/icons";
import ResonanceLayout from "../../components/organisms/ResonanceContext/ResonanceLayout";
import {
  useIonRouter,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from "@ionic/react";

const Profile = (): ReactElement => {
  const { user, endSession } = useContext(AuthContext); // Modified to include endSession
  const { study_slug } = useParams<{ study_slug: string }>(); // Added this line
  const { study } = useConfig();
  const [channel, setChannel] = useState<InvitationChannelDisplayType>();
  const history = useHistory(); // Added this line

  const ionRouter = useIonRouter();

  const handleDisconnect = async () => {
    await endSession();
    resetCaches();
    console.log("study slug:", study_slug); // Log the study slug
    ionRouter.push(`/${study_slug}/welcome`, "root", "replace", {
      unmount: true,
    });
    // history.replace(`/${study_slug}/welcome`);
  }; // Added this function

  const [isLeaveStudyModalOpen, setIsLeaveStudyModalOpen] = useState(false);
  const [isChangePwdModalOpen, setIsChangePwdModalOpen] = useState(false);
  const [isLegalMentionOpen, setIsLegalMentionOpen] = useState(false);
  const [isReportBugOpen, setIsReportBugOpen] = useState(false);
  const { selectedRole } = useConfig();

  const { setResonanceLayout } = useResonanceLayout();
  const theme = useTheme();

  // useEffect(() => {
  //   setResonanceLayout({ });
  // }, []);

  useIonViewWillEnter(() => {
    setResonanceLayout({
      disableHeader: false,
      disableNav: false,
      backgroundColor: "white",
      title: "profile_account",
      welcomePage: false,
    });
  });

  // useIonViewWillLeave(() => {
  //   setResonanceLayout({
  //     disableHeader: false,
  //     disableNav: false,
  //     backgroundColor: "white",
  //     title: "profile_account",
  //     welcomePage: false,
  //   });
  // });

  const canChangePassword = useMemo(
    () =>
      selectedRole?.signin_criteria?.method === IdentificationMethodEnum.EMAIL|| selectedRole?.signin_criteria?.method === IdentificationMethodEnum.NICKNAME_PASSWORD,
    [selectedRole]
  );

  // const checkFakeEmail = (email) => /^user_.*@etudementalo\.fr$/.test(email) ? "" : email
  // helper to validate "real" email
  const getValidEmail = (email?: string) => {
    if (!email) return null;
    if (/^user_.*@etudementalo\.fr$/.test(email)) return null; // fake email
    return email;
  };

  // helper to validate "real" phone
  const getValidPhone = (phone?: string) => {
    if (!phone) return null;
    if (phone === "0607080910") return null; // fake phone
    return phone;
  };

   const getValidNickname = (nickname?: string) => {
    if (!nickname) return null;
    if (nickname.trim() === "") return null;
    return nickname;
  };

  const { t } = useTranslation();

  const handleMentionLegal = () => {
    setIsLegalMentionOpen(true);
  };

  const handleOptOut: () => void = function () {
    setIsLeaveStudyModalOpen(true);
  };

  const handleChangePassword: () => void = function () {
    setIsChangePwdModalOpen(true);
  };
  const [langModalVisible, setLangModalVisible] = useState(false);

  return (
    // <ResonanceLayout isConnected>
    <Container>
      <Section>
        {/* <Header>{t("profile_account")}</Header> */}
        {/* <Field>
          <Icon icon={person} />
          <FieldTitle>{t("profile_name")}</FieldTitle>
          <FieldValue>
            {user.attributes.firstname} {user.attributes.lastname}
          </FieldValue>
        </Field> */}

        {/* Email field only if valid */}
        {getValidEmail(user.attributes.email) && (
          <Field>
            <Icon icon={mail} />
            <FieldTitle>{t("profile_email")}</FieldTitle>
            <FieldValue>{getValidEmail(user.attributes.email)}</FieldValue>
          </Field>
        )}

        {/* Phone field only if valid */}
        {getValidPhone(user.attributes.phone_number) && (
          <Field>
            <Icon icon={phonePortrait} />
            <FieldTitle>{t("profile_phone")}</FieldTitle>
            <FieldValue>
              {getValidPhone(user.attributes.phone_number)}
            </FieldValue>
          </Field>
        )}

          {/* Pseudonym field only if not null/empty */}
        {getValidNickname(user.attributes.nickname) && (
          <Field>
            <Icon icon={person} />
            <FieldTitle>{t("profile_pseudonym")}</FieldTitle>
            <FieldValue>{getValidNickname(user.attributes.nickname)}</FieldValue>
          </Field>
        )}

        {canChangePassword && (
          <Field onClick={handleChangePassword}>
            <Icon icon={lockClosed} />
            <FieldTitle>{t("profile_change_password")}</FieldTitle>
          </Field>
        )}
      </Section>

      <Section>
        <Header>{t("profile_study_info")}</Header>

        <Field onClick={handleOptOut}>
          <Icon icon={removeCircleOutline} />
          <FieldTitle>{t("profile_opt_out")}</FieldTitle>
        </Field>

        {/* <Field onClick={handleMentionLegal}>
          <Icon icon={list} />
          <FieldTitle>{t("mention_legal")}</FieldTitle>
        </Field> */}

        {/* <Field onClick={() => setIsReportBugOpen(true)}>
          <Icon icon={bug} />
          <FieldTitle>{t("profile_report_bug")}</FieldTitle>
        </Field> */}

        {/* <Field onClick={() => setLangModalVisible(true)}>
          <Icon icon={languageOutline} />
          <FieldTitle >
            {t("profil_langue")}
          </FieldTitle>
        </Field> */}

        {/* <Field onClick={handleDisconnect}>
          <Icon icon={logOut} />
          <FieldTitle>{t("menu_logOut")}</FieldTitle>
        </Field> */}
      </Section>

      <LeaveStudyModal
        onDismiss={() => setIsLeaveStudyModalOpen(false)}
        isOpen={isLeaveStudyModalOpen}
      />
      <ChangePwdModal
        onDismiss={() => setIsChangePwdModalOpen(false)}
        isOpen={isChangePwdModalOpen}
      />
      <LegalMentionModal
        onDismiss={() => setIsLegalMentionOpen(false)} // Close Legal Mention Modal
        isOpen={isLegalMentionOpen} // Control modal visibility
      />
      <LanguageSelectorModal
        modalVisible={langModalVisible}
        onCloseClick={() => setLangModalVisible(false)}
      />

      <ReportBugModal
        isOpen={isReportBugOpen}
        onDismiss={() => setIsReportBugOpen(false)}
        user={user}
        study={study}
      />
    </Container>
    // </ResonanceLayout>
  );
};

const Section = styled.div`
  background-color: white;
`;

const Header = styled.div`
  background-color: ${(props) => props.theme.primary.background};
  padding: 20px;
  color: ${(props) => props.theme.primary.contrast};
  margin-bottom: 10px;
  font-size: 18px;
`;

const Field = styled.div.attrs({ tabIndex: 0 })<
  React.HTMLAttributes<HTMLDivElement>
>`
  display: flex;
  flex-direction: row;
  padding: 10px;
  align-items: center;
  font-size: 16px;
  ion-icon {
    font-size: 22px;
    color: ${(props) => props.theme.primary.main};
  }
`;

const FieldTitle = styled.div`
  color: #747474;
  margin-left: 5px;
`;

const FieldValue = styled.div`
  color: ${(props) => props.theme.primary.main};
  margin-left: auto;
`;

export default Profile;
